import React, { useEffect, useState } from "react";
import {
AppBar,
Toolbar,
Typography,
Box,
Avatar,
IconButton,
Menu,
MenuItem,
Badge,
Divider,
Dialog,
DialogTitle,
DialogContent,
DialogActions,
Button,
useMediaQuery,
useTheme
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";

import { useLocation, useNavigate } from "react-router-dom";
import { Colors } from "../utils/colors";
import { adminFetch } from "../services/adminFetch";
import { logout as logoutAction } from "../features/auth/authSlice";
import { logoutAdminSession } from "../services/adminSession";
import { getPageTitle } from "./adminNavigation";
import { broadcastAdminLogout } from "../utils/adminSessionTimeout";

const getDisplayName = (adminProfile) => {
const firstName = String(adminProfile?.first_name || "").trim();
const lastName = String(adminProfile?.last_name || "").trim();
const lastInitial = lastName ? `${lastName.charAt(0).toUpperCase()}.` : "";

return [firstName, lastInitial].filter(Boolean).join(" ");
};

export default function Topbar({ onOpenMenu = () => {} }){

const admin = useSelector((state)=>state.auth.admin);
const dispatch = useDispatch();
const navigate = useNavigate();
const location = useLocation();
const theme = useTheme();
const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

const [anchorEl,setAnchorEl] = useState(null);
const [logoutOpen,setLogoutOpen] = useState(false);
const [messageCount,setMessageCount] = useState(0);
const [adminProfile,setAdminProfile] = useState(null);
const displayName = getDisplayName(adminProfile);
const pageTitle = getPageTitle(location.pathname);

const openMenu = (event)=>{
setAnchorEl(event.currentTarget);
};

const closeMenu = ()=>{
setAnchorEl(null);
};

useEffect(()=>{
const loadMessages = async () => {
try{
const data = await adminFetch("/api/admin/messages",{
method:"GET"
})

if(data?.status){
setMessageCount((data.messages || []).filter((item)=>item.status === "unread").length)
}
}catch(error){
console.log(error)
}
}

loadMessages()
const interval = setInterval(loadMessages, 15000)

return ()=>clearInterval(interval)
},[location.pathname])

useEffect(()=>{
const loadAdminProfile = async () => {
try{
const data = await adminFetch("/api/admin/profile",{
method:"GET"
});

if(data?.status){
setAdminProfile(data.admin || null);
}
}catch(error){
console.log(error)
}
};

loadAdminProfile();
},[])

const openLogoutDialog = ()=>{
closeMenu();
setLogoutOpen(true);
};

const handleLogout = async ()=>{
try{
await logoutAdminSession();
}catch(error){
console.log(error)
}

dispatch(logoutAction());
broadcastAdminLogout({ reason: "manual" });
setLogoutOpen(false);
navigate("/");
};

return(

<AppBar
position="fixed"
sx={{
backgroundColor: Colors.secondary,
boxShadow:"0 2px 10px rgba(0,0,0,0.2)",
boxSizing:"border-box",
maxWidth:"100%",
width:{ lg:"calc(100% - var(--admin-sidebar-width))" },
ml:{ lg:"var(--admin-sidebar-width)" }
}}
>

<Toolbar
sx={{
display:"flex",
justifyContent:"space-between",
minHeight:{ xs:64, sm:70 },
px:{ xs:2, sm:3, lg:4 }
}}
>

<Box sx={{display:"flex", alignItems:"center", gap:1.5, minWidth:0, flex:1}}>
{!isDesktop ? (
<IconButton sx={{ color:"#fff" }} onClick={onOpenMenu} edge="start" aria-label="open menu">
<MenuIcon />
</IconButton>
) : null}

<Typography
variant={isDesktop ? "h6" : "subtitle1"}
sx={{
fontWeight:700,
color:"#fff",
letterSpacing:isDesktop ? 1 : 0,
display:"block",
minWidth:0,
overflow:"hidden",
textOverflow:"ellipsis",
whiteSpace:"nowrap"
}}
>
{pageTitle}
</Typography>
</Box>

<Box sx={{display:"flex", alignItems:"center", gap:{ xs:1, sm:2 }, ml:1, flexShrink:0}}>



<IconButton sx={{color:"#fff"}} onClick={()=>navigate("/admin/messages")}>

<Badge badgeContent={messageCount} color="error">
<NotificationsIcon />
</Badge>

</IconButton>




<Box
onClick={openMenu}
sx={{
display:"flex",
alignItems:"center",
gap:1,
cursor:"pointer",
px:1,
py:0.5,
borderRadius:2,
"&:hover":{
background:"rgba(255,255,255,0.1)"
}
}}
>

<Typography sx={{color:"#fff", fontWeight:500, display:{ xs:"none", sm:"block" }}}>
{displayName || adminProfile?.role || admin || "Admin"}
</Typography>

<Avatar
sx={{
width:32,
height:32,
backgroundColor:"#fff",
color:Colors.secondary2
}}
>
<AccountCircleIcon />
</Avatar>

</Box>




<Menu
anchorEl={anchorEl}
open={Boolean(anchorEl)}
onClose={closeMenu}
PaperProps={{
sx:{
mt:1.5,
minWidth:180,
borderRadius:2
}
}}
>

<MenuItem onClick={()=>{
closeMenu();
navigate("/admin/profile");
}}>
<PersonIcon sx={{mr:1}} />
Profile
</MenuItem>

<Divider />

<MenuItem onClick={openLogoutDialog}>
<LogoutIcon sx={{mr:1}} />
Logout
</MenuItem>

</Menu>

<Dialog open={logoutOpen} onClose={()=>setLogoutOpen(false)}>
<DialogTitle>Logout</DialogTitle>
<DialogContent>
<Typography>
Are you sure you want to log out from the admin dashboard?
</Typography>
</DialogContent>
<DialogActions>
<Button onClick={()=>setLogoutOpen(false)}>Cancel</Button>
<Button variant="contained" color="error" onClick={handleLogout}>
Logout
</Button>
</DialogActions>
</Dialog>

</Box>

</Toolbar>

</AppBar>

)

}
